import { createApp } from './main';

const { app, router, store } = createApp();

if (window.__INITIAL_STATE__) {
  console.log('__INITIAL_STATE__:', JSON.parse(JSON.stringify(window.__INITIAL_STATE__)));
  store.replaceState(window.__INITIAL_STATE__);
}

router.isReady().then(() => {
  app.mount('#app');
});

